import  React, { useState, useEffect } from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Toolbar,
  TextField,
  InputAdornment,
  Icon,
  MenuItem,
  Button,
  Tooltip,
  Badge
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import { getStoreCustomerGroupsApi } from 'api';


const useStyles = makeStyles({
  bgBlue: {
    backgroundColor: '#E7F0FF',
  },
  customSearch: {
    borderTopLeftRadius: '6px',
    borderBottomLeftRadius: '6px',

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E7F0FF'
    },
    '& .MuiInputBase-input::-webkit-input-placeholder': {
      color: '#4B6FC2',
      opacity: '1'
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#4B6FC2'
    }
  },
  customSearchField: {
    borderTopRightRadius: '6px',
    borderBottomRightRadius: '6px',

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E7F0FF'
    },
    '& .MuiInputBase-input::-webkit-input-placeholder': {
      color: '#4B6FC2',
      opacity: '1'
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#4B6FC2'
    },
    '& .MuiInputAdornment-root .MuiTypography-colorTextSecondary': {
      color: '#4B6FC2'
    }
  },
  helperText: {
    position: 'absolute',
    bottom: '-15px',
    left: '25px'
  },
  filterBtn: {
    padding: '7px 15px',
    marginLeft: '10px'
  },
});


const RequestAccessTableToolbar = ({onSearch, checkedCustomers, setOpenFilter, filterConditions}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { customerGroups } = useSelector((state) => state.customers);

  const [searchValue, setSearchValue] = useState('');
  const [searchField, setSearchField] = useState('firstname');

  const selectedConditions = Object.values(filterConditions)
    .filter((condition) => !!condition?.value.length);

  useEffect(() => {
    if (customerGroups) {
      getStoreCustomerGroupsApi({dispatch});
    }
  }, []);

  return (
    <Toolbar>
      <div className="w-full flex justify-between">
        <div className="w-full flex items-center">
          <TextField
            variant="outlined"
            name="search-access-request-value"
            className={`w-full max-w-300 text-primary ${classes.bgBlue} ${classes.customSearch}`}
            placeholder="Search"
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                onSearch(searchValue, searchField);
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {!searchValue.length ?
                    <Icon color="primary">search</Icon>
                    :
                    <Icon
                      color="primary"
                      className="cursor-pointer"
                      onClick={() => {
                        setSearchValue(() => '');
                        onSearch('', 'firstname');
                      }}
                    >
                      close
                    </Icon>
                  }
                </InputAdornment>
              )
            }}
          />
          <TextField
            select
            variant="outlined"
            name="search-request-access-field"
            className={`w-full max-w-300 mr-3 text-primary ${classes.bgBlue} ${classes.customSearchField}`}
            value={searchField}
            onChange={(event) => {
              setSearchField(event.target.value);

              if (searchValue) {
                onSearch(searchValue, event.target.value);
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">by</InputAdornment>
              )
            }}
          >
            <MenuItem value="entity_id">Id</MenuItem>
            <MenuItem value="email">Email</MenuItem>
            <MenuItem value="firstname">First Name</MenuItem>
            <MenuItem value="lastname">Last Name</MenuItem>
            <MenuItem value="group_id">Customer Group</MenuItem>
          </TextField>
          <Button
            color="primary"
            variant="contained"
            className="mr-2 px-3 min-w-120 min-h-40"
            onClick={() => onSearch(searchValue, searchField)}
          >
            <Icon className="mr-2">search</Icon>
            <span className="uppercase">Search</span>
          </Button>
        </div>
        <div className="w-full flex items-center justify-end">
          <Badge
            badgeContent={selectedConditions.length}
            color="primary"
            overlap="rectangular"
          >
            <Tooltip title="Filter by">
              <Button
                className="mr-2"
                variant="outlined"
                color="primary"
                onClick={() => {
                  setOpenFilter(true);
                }}
              >
                <Icon className="text-primary mr-2">
                  filter_list
                </Icon>
                <span className="text-brand">Filter By</span>
              </Button>
            </Tooltip>
          </Badge>
          {checkedCustomers.length >= 2 &&
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              history.push({
                pathname: '/customers/request-access/bulk-edit',
                state: { checkedCustomers }
              });
            }}
          >
            Bulk Edit
          </Button>
          }
        </div>
      </div>
    </Toolbar>
  );
};

export default RequestAccessTableToolbar;
